module.exports = __webpack_public_path__ + "img/features_pic02.2862953a.png";